import React from 'react'
import { useExportHTGIncentivePoint, useGetHTGIncentivePoints } from '../../api/point'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { Chip, Box } from '@mui/material'
import { CompanyBreakdown } from './CompanyBreakdown'

export const HTGIncentivePoints = () => {
  const columns = [
    {
      id: 'companyName',
      label: 'Company Name',
      view: ({ companyName, pointBreakdown }) => (
        <CompanyBreakdown companyName={companyName} pointBreakdown={pointBreakdown} />
      )
    },
    { id: 'primarySalesId', label: 'Primary Sales Id' },
    {
      id: 'salesId',
      label: 'Sales Id',
      view: ({ targetSummary = [] }) => (
        <Box>
          {targetSummary.map((item, index) => (
            <span key={index} style={{ display: 'block' }}>
              {item.salesId || '\u00A0'}
            </span>
          ))}
        </Box>
      )
    },
    {
      id: 'product',
      label: 'Product',
      view: ({ targetSummary = [] }) => (
        <Box>
          {targetSummary.map((item, index) => (
            <span
              key={index}
              style={{
                display: 'block',
                color: item.variance < 0 ? 'red' : 'green'
              }}
            >
              {item.product}
            </span>
          ))}
        </Box>
      )
    },
    {
      id: 'target',
      label: 'Target',
      view: ({ targetSummary = [] }) => (
        <Box>
          {targetSummary.map((item, index) => (
            <span
              key={index}
              style={{
                display: 'block',
                color: item.variance < 0 ? 'red' : 'green'
              }}
            >
              {item.target}
            </span>
          ))}
        </Box>
      )
    },
    {
      id: 'earned',
      label: 'Earned',
      view: ({ targetSummary = [] }) => (
        <Box>
          {targetSummary.map((item, index) => (
            <span
              key={index}
              style={{
                display: 'block',
                color: item.variance < 0 ? 'red' : 'green'
              }}
            >
              {item.earned}
            </span>
          ))}
        </Box>
      )
    },
    {
      id: 'variance',
      label: 'Variance',
      view: ({ targetSummary = [] }) => (
        <Box>
          {targetSummary.map((item, index) => (
            <span
              key={index}
              style={{
                display: 'block',
                color: item.variance < 0 ? 'red' : 'green'
              }}
            >
              {item.variance}
            </span>
          ))}
        </Box>
      )
    },
    {
      id: 'point',
      label: 'Total Points',
      view: ({ totals = {}, boosterPoint }) => (
        <Box>
          <span style={{ display: 'block' }}>Target: {totals.totalTarget}</span>
          <span style={{ display: 'block' }}>Earned: {totals.totalEarned}</span>
          {boosterPoint && <span style={{ display: 'block' }}>Bonus: {boosterPoint}</span>}
          <span
            style={{
              display: 'block',
              color: totals.totalVariance < 0 ? 'red' : 'green'
            }}
          >
            Variance: {totals.totalVariance}
          </span>
        </Box>
      )
    },
    {
      id: 'ticket',
      label: 'Ticket',
      view: ({ ticketSummary = {} }) => (
        <Box>
          <span style={{ display: 'block' }}>Target: {ticketSummary.ticketTarget}</span>
          <span style={{ display: 'block' }}>Earned: {ticketSummary.ticketEarned}</span>
          <span
            style={{
              display: 'block',
              color: ticketSummary.ticketVariance < 0 ? 'red' : 'green'
            }}
          >
            Variance: {ticketSummary.ticketVariance}
          </span>
        </Box>
      )
    },
    { id: 'type', label: 'Type' },
    {
      id: 'bonusEnabled',
      label: 'Bonus',
      view: ({ bonusEnabled }) => (
        <Chip
          label={bonusEnabled ? 'Enabled' : 'Disabled'}
          size='small'
          color={bonusEnabled ? 'success' : 'default'}
        />
      )
    }
  ]

  return (
    <PointPanelScreen
      title='HTG Incentive Point'
      useExportApi={useExportHTGIncentivePoint}
      useGetPoints={useGetHTGIncentivePoints}
      columns={columns}
      linkBase='htg-incentive-summary'
      tableSx={{
        whiteSpace: 'nowrap',
        '& td': { verticalAlign: 'top' }
      }}
    />
  )
}
